<template>
  <div class="elect-label" :class="className" v-inview="{ callback: onInview }">
    <h2 class="elect-label__title" :title="title"><!--
    --><span class="elect-label__year" :style="yearStyle">{{ year }}</span><!--
    --><span class="elect-label__category">{{ category }}</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'ElectLabel',
  props: {
    year: { type: String, required: true },
    category: { type: String, required: true },
    color: { type: String, default: '#a1a1a1' }
  },
  data () {
    return {
      isInview: false
    }
  },
  computed: {
    className () {
      return {
        'elect-label--inview': this.isInview
      }
    },
    yearStyle () {
      return {
        color: this.color
      }
    },
    title () {
      return `${this.year} ${this.category}`
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    }
  }
}
</script>

<style lang="scss">
.elect-label {
  position: relative;
  height: 100px;
  opacity: 0;
  transition: opacity 0.4s;
  @include rwd($RWD_TABLET_SMALL) {
    height: 120px;
  }
  @include rwd($RWD_TABLET) {
    height: 140px;
  }

  &__title {
    position: relative;
    text-align: center;
    height: 100%;
    @include use-vertical-align();
  }

  &__year {
    display: inline-block;
    font-size: 4.5em;
    line-height: 1;
    vertical-align: middle;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 5em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 5.375em;
    }
  }

  &__category {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #1a1a1a;
    font-size: 1.875em;
    font-weight: 500;
    line-height: 1;
    transform: translate(-50%, -50%);
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 2.25em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 2.5em;
    }
  }

  &--inview {
    opacity: 1;
  }
}
</style>
